<p-table [value]="paginationResult.entities" [lazy]="true" (onLazyLoad)="loadData($event)"
  [rows]="paginationRequest.pageSize" [totalRecords]="paginationResult.filteredEntities"
  [rowsPerPageOptions]="[10,20,30,40,50]" [paginator]="true" [(selection)]="selectedEntities" [loading]="loading"
  [rowHover]="true" [showCurrentPageReport]="true"
  currentPageReportTemplate="{first} - {last} {{ 'table.of' | translate }} {totalRecords}" class="custom-table"
  styleClass="p-datatable-striped">

  <!-- #region TABLE TITLE DEFINITION -->
  <ng-template pTemplate="caption">
    <div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title" [ngClass]="{'custom-title-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-title-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
      {{ 'drivers.table.title' | translate }}
    </div>
  </ng-template>
  <!-- #endregion -->

  <!-- #region TABLE COLUMN DEFINITION -->
  <ng-template pTemplate="header">
    <tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
      <!-- SELECT -->
      <th class="checkbox-column">
        <div class="d-flex justify-content-center">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </div>
      </th>
      <!-- NAME -->
      <th pSortableColumn="employee.code">
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.name' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class='d-flex align-items-center h-100'>
            <p-sortIcon field='employee.code'></p-sortIcon>
            <p-columnFilter field='user' type='text' matchMode='contains'
              placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- DATE BIRTH -->
      <th>
        <div class='d-flex align-items-center justify-content-center flex-fill h-100'>
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.birthDate' | translate }}
          </div>
        </div>
      </th>

      <!-- NIF -->
      <th pSortableColumn="employee.nif">
        <div class='d-flex align-items-center justify-content-center flex-fill h-100'>
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.nif' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class='d-flex align-items-center h-100'>
            <p-sortIcon field='employee.nif'></p-sortIcon>
            <p-columnFilter field='nif' type='text' matchMode='contains'
              placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- DATE EXPIRATION NIF -->
      <th>
        <div class='d-flex align-items-center justify-content-center flex-fill h-100'>
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.expirationDateNif' | translate }}
          </div>
        </div>
      </th>

      <!-- DATE EXPEDITION LICENSE -->
      <th>
        <div class='d-flex align-items-center justify-content-center flex-fill h-100'>
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.expeditionDateLicense' | translate }}
          </div>
        </div>
      </th>

      <!-- DATE EXPIRATION LICENSE -->
      <th>
        <div class='d-flex align-items-center justify-content-center flex-fill h-100'>
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.expirationDateLicense' | translate }}
          </div>
        </div>
      </th>

      <!-- OBSERVATIONS -->
      <th pSortableColumn="employee.observations">
        <div class='d-flex align-items-center justify-content-center flex-fill h-100'>
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.observations' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class='d-flex align-items-center h-100'>
            <p-sortIcon field='employee.observations'></p-sortIcon>
            <p-columnFilter field='observations' type='text' matchMode='contains'
              placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- DELEGATION -->
      <th pSortableColumn="employee.subdivision.division.code">
        <div class='d-flex align-items-center justify-content-center flex-fill h-100'>
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.division' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class='d-flex align-items-center h-100'>
            <p-sortIcon field='employee.subdivision.division.code'></p-sortIcon>
            <p-columnFilter field='division' type='text' matchMode='contains'
              placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- SUBDELEGATION -->
      <th pSortableColumn="employee.subdivision.code">
        <div class='d-flex align-items-center justify-content-center flex-fill h-100'>
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.subdivision' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class='d-flex align-items-center h-100'>
            <p-sortIcon field='employee.subdivision.code'></p-sortIcon>
            <p-columnFilter field='subdivision' type='text' matchMode='contains'
              placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- BILLING ACCOUNT -->
      <th pSortableColumn="employee.ceco.billingAccount.code">
        <div class='d-flex align-items-center justify-content-center flex-fill h-100'>
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.company' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class='d-flex align-items-center h-100'>
            <p-sortIcon field='employee.ceco.billingAccount.code'></p-sortIcon>
            <p-columnFilter field='billingAccount' type='text' matchMode='contains'
              placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- CECO -->
      <th pSortableColumn="employee.ceco.code">
        <div class='d-flex align-items-center justify-content-center flex-fill h-100'>
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.ceco' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class='d-flex align-items-center h-100'>
            <p-sortIcon field='employee.ceco.code'></p-sortIcon>
            <p-columnFilter field='ceco' type='text' matchMode='contains'
              placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- IMPORT ERP -->
      <th pSortableColumn="employee.importERP">
        <div class="d-flex align-items-center h-100">
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.importERP' | translate }}
          </div>
          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="employee.importERP"></p-sortIcon>
            <p-columnFilter field="importERP" type="boolean" display="menu" [showApplyButton]="false"></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- ACTIVE -->
      <th pSortableColumn='disabled'>
        <div class='d-flex align-items-center h-100'>

          <!-- COLUMN TITLE -->
          <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
            {{ 'general.active' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class='d-flex align-items-center h-100'>
            <p-sortIcon field='disabled'></p-sortIcon>
            <p-columnFilter field='disabled' type='boolean' display='menu' [showApplyButton]="false"></p-columnFilter>
          </div>

        </div>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-driver>
    <tr class="p-selectable-row custom-rows" [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}" (dblclick)="editDialog(driver)">

      <!-- SELECT -->
      <td>
        <div class="d-flex justify-content-center">
          <p-tableCheckbox [value]="driver"></p-tableCheckbox>
        </div>
      </td>

      <!-- NAME -->
      <td>
        ({{driver.employee.code}}) {{driver.employee.user.surname1}} {{driver.employee.user.surname2}}, {{driver.employee.user.name}}
      </td>

      <!-- DATE BIRTH-->
      <td>
        {{driver.employee.user.birthDate | date: 'dd/MM/yyyy'}}
      </td>

      <!-- NIF -->
      <td>
        {{driver.employee.nif}}
      </td>

      <!-- DATE NIF EXPIRATION -->
      <td>
        {{driver.employee.nifExpirationDate | date: 'dd/MM/yyyy'}}
      </td>

      <!-- EXPEDITION DATE LICENSE -->
      <td>
        @if (driver.licenseData?.length > 0) {
          {{ driver.licenseData[0].expeditionDate | date: 'dd/MM/yyyy' }}
        }
      </td>

      <!-- EXPIRATION DATE LICENSE -->
      <td>
        @if (driver.licenseData?.length > 0) {
          {{ driver.licenseData[0].expirationDate | date: 'dd/MM/yyyy' }}
        }
      </td>

      <!-- OBSERVATIONS -->
      <td>
        {{driver.employee.observations}}
      </td>

      <!-- DIVISION -->
      <td>
        ({{driver.employee.subdivision?.division.code}}) {{driver.employee.subdivision?.division.name}}
      </td>

      <!-- SUBDIVISION -->
      <td>
        ({{driver.employee.subdivision?.code}}) {{driver.employee.subdivision?.name}}
      </td>

      <!-- EMPRESA -->
      <td>
        ({{driver.employee.ceco?.billingAccount.code}}) {{driver.employee.ceco?.billingAccount.name}}
      </td>

      <!-- CECO -->
      <td>
        ({{driver.employee.ceco?.code}}) {{driver.employee.ceco?.description}}
      </td>

      <!-- IMPORT ERP -->
      <td>
        @if (driver.employee.importERP) {
        }
        {{driver.employee.importERP ? 'Si' : 'No'}}
      </td>

      <!-- ACTIVE -->
      <td>
        <div class="d-flex justify-content-center align-items-center">
          <i class="pi"
          [ngClass]="{'true-icon pi-check-circle': !driver.disabled, 'false-icon pi-times-circle': driver.disabled}"></i>
        </div>
      </td>
    </tr>

  </ng-template>
  <!-- TABLE EMPTY MESSAGE -->
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="14" class="p-0">
        <div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
          {{ 'table.tableEmptyMessage' | translate }}!
        </div>
      </td>
    </tr>
  </ng-template>

  <!-- FOOTER -->
  <ng-template pTemplate="footer">
    <tr>
      <td colspan="14" class="p-0">
        <div class="d-flex flex-row align-items-center p-3 gap-3">

          <!-- ADD DRIVER BUTTON -->
          <app-table-add-button [text]="'drivers.table.drivers' | translate " (btnClick)="create()"
          [isDisabled]='!isCreateGranted'></app-table-add-button>

          <!-- CHANGE STATUS BUTTON -->
          <app-table-change-status-button (btnClick)="changeStatus()"
          [isDisabled]="selectedEntities.length === 0 || !isDisabledGranted"></app-table-change-status-button>

          <!-- EXCEL BUTTON -->
          <app-table-excel-button class="buttonTableExcel" (btnClick)="exportExcel()"></app-table-excel-button>
        </div>
      </td>
    </tr>
  </ng-template>

</p-table>


<!-- CHANGE STATUS DIALOG -->
@if (showStatusDialog) {
  <div>
    <app-change-status-shared [items]=" 'drivers.table.drivers' | translate " [display]="true" [service]=driverService
      [entitiesList]=selectedEntities (return)="refreshList($event)"
    (close)="closeStatusDialog($event)"></app-change-status-shared>
  </div>
}

<!-- DRIVER INFO CARD -->
<app-driver-info-card></app-driver-info-card>